import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";
import { EvergreenCounterService } from "./EvergreenCounterService";

interface IUnit {
	def: string;
	field: string;
	minutes: number;
}

const units: readonly IUnit[] = [
	{
		def: "day",
		field: "day",
		minutes: 1440
	},
	{
		def: "hour",
		field: "hour",
		minutes: 60
	}
];

export class EvergreenCounter extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		if (this.endpoint) {
			const service = EvergreenCounterService.getOrCreateInstance(
				this.endpoint,
				this.delay
			);

			service.addUpdateListener(result => this.update(result));
			service.start();
		}
	}

	get delay(): number {
		const defaultDelay = 600;
		const minimumDelay = 3;
		const millisecondsInSecond = 1000;
		const raw = this._element.dataset.updateTimer || "";
		const parsed = parseInt(raw, 10);
		const delay = isNaN(parsed) ? defaultDelay : parsed;

		return Math.max(delay, minimumDelay) * millisecondsInSecond;
	}

	private get endpoint(): string {
		return this._element.dataset.endpoint || "";
	}

	private get giftedLabel(): string {
		return this._element.dataset.gifted || "gifted";
	}

	private get separator(): string {
		return this._element.dataset.separator || "&";
	}

	private resolveLabel(count: number, unit: IUnit): string {
		const singular = this._element.dataset[unit.field] || unit.def;

		return count === 1 ? singular : singular + "s";
	}

	private update(totalMinutes: number): void {
		let remainingMinutes = totalMinutes;
		const message = units
			.map(x => {
				const count = Math.floor(remainingMinutes / x.minutes);

				if (count > 0) {
					remainingMinutes -= count * x.minutes;

					return count.toLocaleString() + " " + this.resolveLabel(count, x);
				}
			})
			.filter(Boolean)
			.join(" " + this.separator + " ");

		this._element.textContent = message ? message + " " + this.giftedLabel : "";
	}
}

ComponentFactory.registerComponent("evergreenCounter", EvergreenCounter);
